// src/theme/atomic/purple.ts
var purple = {
  99: "#FEFBFF",
  95: "#F9EDFF",
  90: "#F2D6FF",
  80: "#E9BAFF",
  70: "#DE96FF",
  60: "#D478FF",
  50: "#CB59FF",
  40: "#AD36E3",
  30: "#861CB8",
  20: "#580A7D",
  10: "#290247"
};
var purple_default = purple;

export { purple_default as default };
